<div *ngIf="claim">

    <div *ngIf="!showFullCard">
        <div class="flex align-items-start p-2">
            <ng-icon *ngIf="!selected" name="bootstrapPersonRolodex" size="2em" color="var(--primary-color)"></ng-icon>
            <span *ngIf="selected" class="bg-primary p-2 border-round pb-1"><ng-icon  name="bootstrapPersonRolodex" size="2em" color="white"></ng-icon></span>
        </div>
    </div>

    <div class="p-2 card">
        <p-card *ngIf="showFullCard" >
            <p-panel [toggleable]="true" [collapsed]="!panelExpanded" expandIcon="pi pi-chevron-up" collapseIcon="pi pi-chevron-down">
                <ng-template pTemplate="header">
                    <div class="flex align-items-start mr-4" [ngClass]="selected ? 'selected' : ''">
                        <ng-icon *ngIf="!selected" name="bootstrapPersonRolodex" size="2em" color="var(--primary-color)"></ng-icon>
                        <ng-icon *ngIf="selected" name="bootstrapPersonRolodex" size="2em" color="white"></ng-icon>

                    </div>
                    <div class="flex align-items-start justify-content-start flex-column">
                        <div class="flex align-items-start">
                            <span style="font-size: 1.2rem; font-weight: bold;" [ngClass]="selected?'selected':''" >{{claim.claimNumber}}</span>
                        </div>
                        <div class="flex align-items-start">
                            <span style="font-size: .9rem; font-weight: bold;" [ngClass]="selected?'selected':''">{{claim.party.displayName}}</span>
                        </div>
                        <div class="flex align-items-start">
                            <span style="font-size: .9rem; font-weight: bold;" [ngClass]="selected?'selected':''">{{claim.bodyPart}}</span>
                        </div>
                    </div>
                </ng-template>
                <div class="flex flex-row flex-auto w-full align-items-start">
                    
                    <p-tieredMenu [model]="menuItems" [style]="{'font-size':'.9rem'}" (onShow)="loadClaimEncounters()" />
                    <p-confirmDialog></p-confirmDialog>
    
                </div>
            </p-panel>
            
        </p-card>
    </div>
</div>


<!-- Panels for the individual details -->
<!-- <p-dialog appendTo="body" #partyDialog header="Injured Worker" [modal]="true" [visible]="(partyPanelShown$ | async ) ?? false"  (visibleChange)="hidePartyPanel($event)" closable closeOnEscape styleClass="flex h-auto w-6"> -->
<p-dialog #partyDialog header="Injured Worker" [modal]="true" [(visible)]="partyDialogVisible" closable closeOnEscape styleClass="flex h-auto w-6">

    <!-- <p-card *ngIf="! (editParty$ | async) && claim && claim.party"> -->
    <p-card *ngIf="! editingParty && claim && claim.party">

        <div class="flex flex-column w-full">
            <div class="flex flex-row align-items-center gap-2 w-full">
                <div class="flex flex-column w-full justify-content-center">
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">First Name</div><div class="col-6">{{claim.party.firstName}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Last Name</div><div class="col-6">{{claim.party.lastName}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Date Of Birth</div><div class="col-6">{{claim.party.dateOfBirth | date : 'shortDate'}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Injured worker has opted in for email updates</div>
                        <div class="col-6">{{claim.party.optedInToStatusUpdates ? 'Yes' : 'No'}}</div>
                    </div>

                </div>
                <div><p-button icon="pi pi-pencil" text (onClick)="editParty($event)"></p-button></div>
            </div>

            <div class="flex flex-row w-full align-items-start">
                <div class="flex w-4 flex-column justify-content-center">
                    <div><h5>Address</h5></div>
                    <div *ngFor="let address of claim.party.addresses" class="flex flex-row">
                        <div class="flex w-1">
                            <i *ngIf="address.addressType == 0" class="pi pi-star-fill"></i>
                        </div>
                        <div class="flex w-11 flex-column">
                            <div>{{address.location.street1}}</div>
                            <div>{{address.location.street2}}</div>
                            <div>{{address.location.city}}, {{address.location.state}} {{address.location.zipCode}}</div>
                        </div>
                       
                    </div>
                </div>
                <div class="flex w-4 flex-column justify-content-center">
                    <div><h5>Phone</h5></div>
                    <div *ngFor="let phone of claim.party.phones" class="flex flex-column w-full">
                        <div class="flex w-full flex-row">
                            <span class="flex w-1"><i *ngIf="phone.phoneType == 0" class="pi pi-star-fill"></i></span>
                            <span class="flex w-1"><i *ngIf="phone.smsCapable" class="pi pi-mobile"></i></span>
                            <span class="flex w-10 pl-2">{{phone.e164PhoneNumber}}</span>
                        </div>
                    </div>
                </div>
                <div class="flex w-4 flex-column justify-content-center">
                    <div><h5>Email</h5></div>
                    <div *ngFor="let email of claim.party.emails" class="flex flex-column w-full">
                        <div class="flex w-full flex-row">
                            <span class="flex w-1"><i *ngIf="email.emailType == 0" class="pi pi-star-fill"></i></span>
                            <span class="flex w-11 pl-2">{{email.emailAddress}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-card>
    <!-- <app-party-editor *ngIf="claim && partyForEdit && (editParty$ | async)" [party]="partyForEdit" (saved)="updateParty($event);" (cancelled)="partyEditCancelled()" ></app-party-editor> -->
    <app-party-editor *ngIf="claim && partyForEdit && editingParty" [party]="partyForEdit" (saved)="updateParty($event);" (cancelled)="partyEditCancelled()" ></app-party-editor>

</p-dialog>

<!-- <p-dialog appendTo="body" #claimDialog header="Claim" [modal]="true" [visible]="(claimPanelShown$ | async) ?? false" (visibleChange)="hideClaimPanel($event)" closable closeOnEscape styleClass="flex h-auto w-6"> -->
<p-dialog #claimDialog header="Claim" [modal]="true" [(visible)]="claimDialogVisible"  closable closeOnEscape styleClass="flex h-auto w-6">
    <p-card *ngIf="! editingClaim && claim">
        <div class="flex flex-column w-full">
            <div class="flex flex-row align-items-center gap-2 w-full">
                <div class="flex flex-column w-full justify-content-center">
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Adjuster</div>
                        <div class="flex col-6 flex-column">
                            <div>{{claim.adjuster?.fullName}}</div>
                            <div class="flex flex-row align-items-center pt-1"><i class="flex pr-2 pi pi-envelope"></i>{{claim.adjuster?.emailAddress}}</div>
                            <div class="flex flex-row align-items-center pt-1"><i class="flex pr-2 pi pi-phone"></i> {{claim.adjuster?.phoneNumber}}</div>
                        </div>
                    </div>
                    <div *ngIf="claim.adjuster2" class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Second Adjuster</div>
                        <div class="flex col-6 flex-column">
                            <div>{{claim.adjuster2.fullName}}</div>
                            <div class="flex flex-row align-items-center pt-1"><i class="flex pr-2 pi pi-envelope"></i>{{claim.adjuster2.emailAddress}}</div>
                            <div class="flex flex-row align-items-center pt-1"><i class="flex pr-2 pi pi-phone"></i> {{claim.adjuster2.phoneNumber}}</div>
                        </div>
                    </div>
                    <div *ngIf="claim.adjusterSupervisor" class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Adjuster Supervisor</div>
                        <div class="flex col-6 flex-column">
                            <div>{{claim.adjusterSupervisor.fullName}}</div>
                            <div class="flex flex-row align-items-center pt-1"><i class="flex pr-2 pi pi-envelope"></i>{{claim.adjusterSupervisor.emailAddress}}</div>
                            <div class="flex flex-row align-items-center pt-1"><i class="flex pr-2 pi pi-phone"></i> {{claim.adjusterSupervisor.phoneNumber}}</div>
                        </div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Payer</div><div class="col-6">{{claim.carrier?.name}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Claim Number</div><div class="col-6">{{claim.claimNumber}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Claim Date</div><div class="col-6">{{claim.claimDate | date : 'shortDate'}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Body Part</div><div class="col-6">{{claim.bodyPart}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Accident Description</div><div class="col-6">{{claim.accidentDescription}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Injury Description</div><div class="col-6">{{claim.injuryDescription}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Case Manager</div><div class="col-6">{{claim.caseManager}}</div>
                    </div>
                    <div class="w-full flex grid">
                        <div class="flex justify-content-end font-bold col-6">Contact Info</div><div class="col-6">{{claim.contactInfo}}</div>
                    </div>
                    

                </div>
                <div><p-button icon="pi pi-pencil" text (onClick)="editClaim($event)"></p-button></div>
            </div>
        </div>
    </p-card>
    <app-claim-editor *ngIf="claim && claimForEdit && editingClaim" [claim]="claimForEdit" (saved)="updateClaim($event);" (cancelled)="claimEditCancelled()" ></app-claim-editor>

</p-dialog>

<p-dialog #encounterDialog>

</p-dialog>